import { bool, node, string } from "prop-types";
import { memo } from "react";
import classNames from "classnames";

interface LabelProps {
  htmlFor: string;
  overrideClass?: string;
  children: any;
  requiredField: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function CustomLabel({ htmlFor, overrideClass, children, requiredField, ...rest }: LabelProps) {
  return (
    <label
      className={classNames(
        `mb-1 text-black text-xs text-left !font-montserrat font-bold `,
        overrideClass
      )}
      htmlFor={htmlFor}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {children}
      {requiredField ? <span className="text-hotShot">*</span> : null}
    </label>
  );
}

CustomLabel.propTypes = {
  overrideClass: string,
  htmlFor: string,
  children: node.isRequired,
  requiredField: bool
};

CustomLabel.defaultProps = {
  overrideClass: "",
  requiredField: false,
  htmlFor: ""
};

export default memo(CustomLabel);
